import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import SoundAssetKeys from '../SoundAssetKeys';

export default class SenseButton extends Phaser.GameObjects.Container {
  constructor(scene, senseName, silent = true) {
    super(scene);
    scene.add.existing(this);

    this.scene = scene;
    this.senseName = senseName;
    this.isSilent = silent;

    this.selectedBg = ABCyaPhaser.Images.addImage(0, 0, 'SenseButton_Selected', this);
    this.selectedBg.alpha = 0;

    this.bg = ABCyaPhaser.Images.addImage(0, 0, 'SenseButtonBg', this);
    this.bg.alpha = 0;

    this.icon = ABCyaPhaser.Images.addImage(0, 0, `SenseIcon_${this.senseName}`, this);
    this.icon.alpha = 0;
  }

  popin() {
    if (!this.isSilent) ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop1, this.scene);

    this.selectedBg.scaleX = 0;
    this.selectedBg.scaleY = 0;
    this.selectedBg.alpha = 0;
    ABCyaPhaser.Tweens.addTween(this.selectedBg, 440,{ scaleX: 1, scaleY: 1, alpha: 1 },Phaser.Math.Easing.Back.Out);

    this.bg.scaleX = 0;
    this.bg.scaleY = 0;
    this.bg.alpha = 0;
    ABCyaPhaser.Tweens.addTween(this.bg, 480,{ scaleX: 1, scaleY: 1, alpha: 1 },Phaser.Math.Easing.Back.Out, () => {
      this.showIconIn();
    });
  };

  displayButton() {
    this.bg.scaleX = 1;
    this.bg.scaleY = 1;
    this.bg.alpha = 1;
    this.icon.alpha = 1;
  };

  showIconIn() {
    this.icon.alpha = 0;
    if (!this.isSilent) ABCyaPhaser.Audio.playOneShot(this.senseName, this.scene, 1, false, 0, ABCyaPhaser.Audio.LOCALIZATION_AUDIO_SPRITE);

    ABCyaPhaser.Tweens.addTween(this.icon, 360,{ alpha: 1 },Phaser.Math.Easing.Quadratic.In, () => {
      this.popinFinished();
    });
  };

  popinFinished() {
    this.emit('REVEAL_FINISHED');
  };

  popout() {
    if (!this.isSilent) ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._pop1, this.scene);

    ABCyaPhaser.Tweens.addTween(this.selectedBg, 440,{ scaleX: 0, scaleY: 0 },Phaser.Math.Easing.Back.In);
    ABCyaPhaser.Tweens.addTween(this.bg, 300,{ scaleX: 0, scaleY: 0 },Phaser.Math.Easing.Back.In);
    ABCyaPhaser.Tweens.addTween(this.icon, 300,{ alpha: 0 },Phaser.Math.Easing.Quadratic.In);
  };

  select() {
    this.selectedBg.scaleX = 1;
    this.selectedBg.scaleY = 1;
    ABCyaPhaser.Tweens.addTween(this.selectedBg, 300,{ alpha: 1 },Phaser.Math.Easing.Linear);
  };

  hideSelectionBg() {
    this.selectedBg.alpha = 0;
  };

  deselect() {
    ABCyaPhaser.Tweens.addTween(this.selectedBg, 300,{ alpha: 0 },Phaser.Math.Easing.Linear);
  };
}